import { Controller } from "@hotwired/stimulus"

// Mirrors the React profile-picture behaviour: if the <img> fails to load
// (including cached broken images, which don't fire `error`), remove it so the
// initials fallback rendered underneath becomes visible.
export default class extends Controller {
  static targets = ["image"]

  connect() {
    if (!this.hasImageTarget) return

    const img = this.imageTarget
    if (img.complete && img.naturalWidth === 0) {
      this.onError()
    }
  }

  onError() {
    if (this.hasImageTarget) this.imageTarget.remove()
  }
}
